<template>
  <div v-if="showReply" >
    <v-card outlined :color="'light-blue lighten-5'">
      <v-card-text>

        <v-form ref="chatForm" v-model="chatValid">
          <v-row>
             <v-col cols="12" >
                <v-card color="" outlined class="pa-3">
                    <span>{{selectedToReply.body.length>50 ?selectedToReply.body.slice(0,50)+ '...' :selectedToReply.body}}</span>
                </v-card>
             </v-col>
            <v-col cols="12">
              <v-textarea
                label="متن پیام"
                outlined
                dense
                required
                :rules="[
                  (v) => {
                    if(!v){
                      return 'وارد کردن متن پیام الزامی میباشد'
                    }
                    if (v && (v.length > 4096 || v.length <8 ) ){
                        return 'تعداد کاراکتر ها باید بین 8 تا 4096 عدد باشد';
                      }
                    
                    else return true;
                    }
                ]"
                v-model="chat.body"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <new-files-uploader
                :files="attachments"
                ref="filesUploder"
              ></new-files-uploader>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="error" small @click="closeForm()">  انصراف </v-btn>
        <v-btn color="primary" small @click="sendReply()">
          ارسال پیام</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import NewFilesUploader from '@/components/core/NewFilesUploader';
import Helper from '@/core/helpers';
const businessInformationConversationRepository = () =>
  RepoFactory.get('businessInformationConversation');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  props: {
    showReply: {
      type: Boolean,
      default: false,
    },
    selectedToReply: {
      type: Object,
      default: null,
    },
  },
  components: {
    NewFilesUploader,
  },
  data() {
    return {
      chatValid: true,
      chat: {
        body: null,
        attachments: [],
      },
      attachments: [],
    };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {

  },
  watch: {

  },
  methods: {

    closeForm() {
      this.$emit('closeReplyForm');
    },
    sendMessage() {
      if (this.$refs.chatForm.validate()) {
        if (
          this.$refs.filesUploder.uploadedFilesId &&
          this.$refs.filesUploder.uploadedFilesId.length
        ) {
          this.chat.attachments = this.$refs.filesUploder.uploadedFilesId;
        }
        if (!this.chatIsEdit) {
          this.createMessage();
        } else {
          this.editMessage();
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن متن پیام الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    sendReply() {
      const loader = this.$loading.show();
      this.chat.conversationId = this.selectedToReply.conversationId;
      this.chat.objectId = this.$store.getters.currentMerchant;
      this.chat.createdByMerchantId = this.$store.getters.currentMerchant;
      this.chat.recipientUserId = null
      this.chat.recipientMerchantId = null
      this.chat.type = 'AdminMerchant'
      this.chat.topic = 'Merchant'
      this.chat.attachments= null
      this.chat.parentId = this.selectedToReply.id

      businessInformationConversationRepository()
        .addConversation(this.chat, this.baseUrl)
        .then((data) => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          this.$emit('getBusinessInformationConversaion');
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
   
  },
};
</script>

<style></style>
